import { Injectable } from "@angular/core";
import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { firstValueFrom, from, Observable } from "rxjs";
import { UserConfigurationRepo } from "@app/core/user/domain/repositories/user-configuration.repo";
import { MissingCredentialsError } from "@app/core/shared/domain/missing-credentials.error";
import { UserConfiguration } from "@app/core/user/domain/user-configuration";

@Injectable({
  providedIn: "root",
})
export class GetUserConfigurationUseCase {
  constructor(
    private tokenRepo: TokenRepo,
    private userConfigurationRepo: UserConfigurationRepo
  ) {}

  execute(): Observable<UserConfiguration | null> {
    return from(this.getUserConfiguration());
  }

  private async getUserConfiguration(): Promise<UserConfiguration | null> {
    const token = this.tokenRepo.getTemporal() ?? this.tokenRepo.get();
    if (token == null) {
      throw new MissingCredentialsError();
    }
    return firstValueFrom(this.userConfigurationRepo.get(token));
  }
}
